import { FC } from 'react';

import dashboardFiltersButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_filters_button_click';
import { Badge, Button, useBreakpoint } from '@hh.ru/magritte-ui';
import { AdjustmentsOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { AllFiltersModal } from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/components/AllFiltersModal/AllFiltersModal';

import { useSelector } from 'store/utils';

const TrlKeys = {
    button: 'CampaignsFiltersPanel.components.AllFiltersButton.button',
};

export const AllFiltersButton: FC = () => {
    const isCampaignsFiltersLoading = useSelector((state) => state.campaignsFilters.isCampaignsFiltersLoading);
    const appliedCampaignsFiltersTotalCount = useSelector(
        (state) => state.campaignsFilters.appliedCampaignsFiltersTotalCount
    );

    const [isModalVisible, setIsModalVisibleOn, setIsModalVisibleOff] = useOnOffState(false);

    const trls = useTrls();
    const { isMobile } = useBreakpoint();
    const label = trls(TrlKeys.button);
    const badge =
        appliedCampaignsFiltersTotalCount > 0 ? (
            <Badge size="small">{String(appliedCampaignsFiltersTotalCount)}</Badge>
        ) : undefined;

    const handleClick = () => {
        dashboardFiltersButtonClick();
        setIsModalVisibleOn();
    };

    return (
        <>
            <Button
                data-qa="campaigns-all-filters-button"
                mode="secondary"
                style="neutral"
                icon={<AdjustmentsOutlinedSize24 />}
                onClick={handleClick}
                disabled={isCampaignsFiltersLoading}
                badge={badge}
                hideLabel={isMobile}
                aria-label={isMobile ? label : undefined}
            >
                {label}
            </Button>
            <AllFiltersModal visible={isModalVisible} onClose={setIsModalVisibleOff} />
        </>
    );
};
